import { Backdrop, Box, IconButton, useMediaQuery, useTheme } from '@mui/material';
import React, { useRef, useState } from 'react';
import Slider from 'react-slick';
import Stories from 'react-insta-stories';
import Iconify from '../../fl-components/Iconify';
import { useStoryPreviewAuth } from '../../context/StoryPreviewContext';
import { CarouselDots, CarouselArrows } from '../../fl-components/carousel';

export default function DiscoverStories() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { storiesOpen, storiesData, closeStoryViewer } = useStoryPreviewAuth();
  const carouselRef = useRef(null);
  // Content Index
  const [currentContentIndex, setCurrentContentIndex] = useState(0);
  // Story Index
  const [parentStoryIndex, setParentStoryIndex] = useState(0);

  const settings = {
    dots: false,
    arrows: false,
    draggable: false,
    // className: 'center',
    // centerMode: true,
    // speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    rtl: true,
    ...CarouselDots()
  };

  const handlePrevious = () => {
    if (storiesData.length <= parentStoryIndex) {
      if (storiesData[0].length > 1) setCurrentContentIndex(1);
      setParentStoryIndex(0);
      return;
    }
    if (currentContentIndex === 0) {
      setCurrentContentIndex(storiesData[parentStoryIndex - 1].length);
      setParentStoryIndex(parentStoryIndex - 1);
      carouselRef.current?.slickPrev();
      return;
    }
    if (storiesData[parentStoryIndex].length > currentContentIndex - 1) {
      setCurrentContentIndex(currentContentIndex - 1);
    } else {
      setCurrentContentIndex(0);
      setParentStoryIndex(parentStoryIndex - 1);
      // sliderOnClick();
      carouselRef.current?.slickPrev();
    }
  };

  const handleNext = () => {
    if (storiesData.length <= parentStoryIndex) {
      if (storiesData[0].length > 1) setCurrentContentIndex(1);
      setParentStoryIndex(0);
      return;
    }
    if (storiesData[parentStoryIndex].length > currentContentIndex + 1) {
      setCurrentContentIndex(currentContentIndex + 1);
    } else {
      setCurrentContentIndex(0);
      setParentStoryIndex(parentStoryIndex + 1);
      // sliderOnClick();
      carouselRef.current?.slickNext();
    }
  };

  return (
    <Box sx={{ position: 'relative', zIndex: 1200, width: '100%', height: '100%' }}>
      {isMobile ? (
        <Backdrop
          open={storiesOpen}
          sx={{
            zIndex: 1200,
            background: 'rgba(0, 0, 0, 0.9)'
          }}
        >
          <IconButton
            sx={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              zIndex: 1002,
              display: {
                sm: 'unset',
                md: 'none'
              }
            }}
            onClick={() => closeStoryViewer()}
          >
            <Iconify
              icon="ant-design:close-circle-outlined"
              width={40}
              height={40}
              sx={{ color: 'black' }}
            />
          </IconButton>
          <Stories
            stories={storiesData[parentStoryIndex]}
            defaultInterval={7000}
            width="100%"
            height="100%"
            onStoryEnd={(e) => {
              if (storiesData.length !== e + 1) {
                handleNext();
              } else {
                setParentStoryIndex(parentStoryIndex + 1);
              }
            }}
            currentIndex={currentContentIndex}
            storyContainerStyles={{
              margin: '0 auto'
            }}
            storyStyles={{
              width: 'auto',
              maxWidth: '100%',
              maxHeight: '100%',
              margin: 'auto'
            }}
          />
        </Backdrop>
      ) : (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 100,
            width: '100%',
            height: '100%',
            flexDirection: 'column',
            background: 'rgba(0, 0, 0, 0.9)',
            justifyContent: 'center',
            display: 'flex'
          }}
        >
          <IconButton
            sx={{
              position: 'absolute',
              top: '15px',
              right: '15px'
            }}
            onClick={() => closeStoryViewer()}
          >
            <Iconify
              icon="ant-design:close-circle-outlined"
              width={40}
              height={40}
              sx={{ color: 'white' }}
            />
          </IconButton>
          <CarouselArrows
            filled
            onNext={handleNext}
            onPrevious={handlePrevious}
            sx={{
              '& .arrow button': {
                p: 0,
                width: 24,
                height: 24,
                top: -20
              }
            }}
          >
            <Slider ref={carouselRef} {...settings}>
              {storiesData.map((sd, index) => (
                <Box
                  key={index}
                  position="relative"
                  sx={{
                    height: {
                      xs: '100%',
                      md: 768
                    },
                    width: {
                      xs: 'auto ',
                      md: 432
                    }
                  }}
                >
                  <Stories
                    stories={sd}
                    defaultInterval={7000}
                    width={432}
                    height={738}
                    onStoryEnd={() => {
                      if (storiesData.length !== index + 1) {
                        handleNext();
                      }
                    }}
                    currentIndex={currentContentIndex}
                    storyContainerStyles={{
                      margin: '0 auto'
                    }}
                    storyStyles={{
                      width: 'auto',
                      maxWidth: '100%',
                      maxHeight: '100%',
                      margin: 'auto'
                    }}
                  />
                </Box>
              ))}
            </Slider>
          </CarouselArrows>
        </Box>
      )}
    </Box>
  );
}
